'use client';

import React, { useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { useEstimator } from '../../context/EstimatorContext';

const CostAssumptionsGrid = () => {
  const { formData, setFormData } = useEstimator();

  const [assumptions, setAssumptions] = useState(
    formData.costAssumptions?.length > 0
      ? formData.costAssumptions
      : [
          { type: 'Tax Rate', value: '' },
          { type: 'Contingency', value: '' },
          { type: 'Overhead', value: '' },
          { type: 'Row $/ft', value: formData.averageROWCostPerFoot },
        ]
  );

  const columnDefs = useMemo(
    () => [
      {
        headerName: 'Type',
        field: 'type',
        editable: false,
        cellStyle: { backgroundColor: '#f0f0f0', color: '#333' },
        flex: 1,
      },
      {
        headerName: 'Value',
        field: 'value',
        editable: (params) => params.data.type !== 'Row $/ft',
        flex: 1,
        cellStyle: (params) =>
          params.data.type === 'Row $/ft'
            ? { backgroundColor: '#f0f0f0', color: '#999' }
            : { backgroundColor: '#ffffff', color: '#000' },
      },
    ],
    []
  );

  const handleGridEdit = (event) => {
    const updated = [...assumptions];
    updated[event.node.rowIndex] = event.data;
    setAssumptions(updated);
    setFormData((prev) => ({ ...prev, costAssumptions: updated }));
  };

  return (
    <Box>
      <Typography
        variant="h6"
        mb={2}
        sx={{
          backgroundColor: '#A7B9D1',
          color: 'white',
          padding: '8px 16px',
          borderRadius: 1,
        }}
      >
        Cost Assumptions
      </Typography>

      <Box sx={{ maxHeight: 300, overflowY: 'auto', width: '100%' }}>
        <AgGridReact
          rowData={assumptions}
          columnDefs={columnDefs}
          defaultColDef={{ resizable: true, cellStyle: { textAlign: 'left' } }}
          onCellValueChanged={handleGridEdit}
          domLayout="autoHeight"
          suppressMovableColumns
        />
      </Box>
    </Box>
  );
};

export default CostAssumptionsGrid;
